module.exports = __webpack_public_path__ + "static/media/Lesson-4-30-Let-us-be-One-Spirit.26dae844.pdf";